import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Badge, Column, Row, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useCobConfig } from '~/client-flow/clientOb/CobConfigContext';
import { SignatureInput } from '~/client-flow/clientOb/components/SignatureInput';
import { useResponsive } from '~/client-flow/contexts';
import { useStore } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { fullName } from '~/infra/utils';
import { relationshipModel } from '~/models';
import { selectors } from '~/store/state-selectors';
import { Reason } from '../../../../ClientOnboarding.utils';
import { useSignAndApproveContext } from '../../../hooks/useSignAndApprove';
import styles from './SignAndApprove.module.scss';
export const { SignAndApproveTestIds } = getTestIds();
function AdditionalSignatories(param) {
    let { relationship, userId } = param;
    var _relationship_signatories, _relationshipModel_buyerFullName;
    const { t: signTexts } = useLocaleKeys('clientFlow.signAndApprove');
    const signatories = (_relationship_signatories = relationship.signatories) !== null && _relationship_signatories !== void 0 ? _relationship_signatories : [];
    const isBuyer = relationshipModel.isBuyer(relationship, userId);
    const rows = isBuyer ? signatories.map((s)=>{
        var _fullName;
        return {
            name: (_fullName = fullName(s.firstName, s.lastName)) !== null && _fullName !== void 0 ? _fullName : s.email,
            status: s.approvalRecord ? signTexts.signed() : signTexts.awaitingSignature()
        };
    }) : [
        ...relationship.buyer.id !== userId ? [
            {
                name: (_relationshipModel_buyerFullName = relationshipModel.buyerFullName(relationship)) !== null && _relationshipModel_buyerFullName !== void 0 ? _relationshipModel_buyerFullName : relationship.buyer.email,
                status: relationship.approvalRecord ? signTexts.signed() : signTexts.awaitingSignature()
            }
        ] : [],
        ...signatories.filter((s)=>s.id !== userId).map((s)=>{
            var _fullName;
            return {
                name: (_fullName = fullName(s.firstName, s.lastName)) !== null && _fullName !== void 0 ? _fullName : s.email,
                status: s.approvalRecord ? signTexts.signed() : signTexts.awaitingSignature()
            };
        })
    ];
    if (rows.length === 0) return null;
    return /*#__PURE__*/ _jsxs(Column, {
        gap: 8,
        alignItems: "start",
        testId: SignAndApproveTestIds.AdditionalSignatories(),
        className: styles.additionalSignatories,
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraph1",
                weight: "bold",
                children: signTexts.additionalSignatories()
            }),
            rows.map((row, i)=>/*#__PURE__*/ _jsxs(Row, {
                    className: styles.signatoryRow,
                    gap: 8,
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: "paragraph1",
                            skin: "secondary",
                            children: row.name
                        }),
                        /*#__PURE__*/ _jsx(Badge, {
                            rounded: true,
                            outlined: true,
                            skin: "primary",
                            className: styles.statusBadge,
                            children: row.status
                        })
                    ]
                }, i))
        ]
    });
}
export const SignAndApprove = ()=>{
    const { t: signAndApproveTexts } = useLocaleKeys('clientFlow.signAndApprove');
    const { relationship, isPreview } = useCobConfig();
    const userId = useStore(selectors.user.id);
    const { signature, setSignature, baseDisabled, disabledReason } = useSignAndApproveContext();
    const { isMobile } = useResponsive();
    const signatureDisabled = isPreview ? false : baseDisabled && disabledReason !== Reason.ApproveTermsOfServices;
    return /*#__PURE__*/ _jsxs(Column, {
        gap: 24,
        alignItems: "start",
        children: [
            /*#__PURE__*/ _jsx(SignatureInput, {
                value: signature,
                onChange: setSignature,
                disabled: signatureDisabled,
                placeholder: signAndApproveTexts.typeName(),
                isMobile: isMobile
            }),
            relationshipModel.hasSignatories(relationship) && /*#__PURE__*/ _jsx(AdditionalSignatories, {
                relationship: relationship,
                userId: userId
            })
        ]
    });
};
